import { render } from "./LeaveComment.vue?vue&type=template&id=3743ed1a&scoped=true"
import script from "./LeaveComment.vue?vue&type=script&lang=js"
export * from "./LeaveComment.vue?vue&type=script&lang=js"

import "./leave-comment.scss?vue&type=style&index=0&id=3743ed1a&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3743ed1a"]])

export default __exports__